import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M31.707 13.389a1 1 0 0 0-1.415 0L24 19.682 13.414 9.096l6.293-6.292a1.001 1.001 0 0 0-1.415-1.415L12 7.682a2 2 0 0 0-.353 2.351L9 12.684a2 2 0 0 0 0 2.827l.586.586-7.294 7.293a1 1 0 0 0 .392 1.656l9 3a1.002 1.002 0 0 0 1.024-.241L17 23.51l.586.586a2 2 0 0 0 2.828 0l2.648-2.648a2 2 0 0 0 2.352-.352l6.293-6.292a1 1 0 0 0 0-1.415M11.73 25.952l-6.875-2.294L11 17.51l4.586 4.586zm7.27-3.27-8.586-8.586L13 11.51l8.586 8.586z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconAnnotate = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconAnnotate);
export default Memo;
